import React from "react";
import { FormattedHTMLMessage } from "react-intl";
import Section from "../components/Section";
import { NavLink } from "react-router-dom";
import queryString from "query-string";
export default ({ location }) => {
  const locationId = location.pathname.split("/")[1];
  const query = queryString.parse(location.search || "?l=it");
  const languageID = query.l || "it";
  return (
    <Section id='home'>
      <a href={`/new-energy?l=${languageID}`} target='_blank'>
        <div
          className='news-image'
          style={{ backgroundImage: 'url("images/icons/news.png")' }}
        >
          <FormattedHTMLMessage id='pages:home:news-title' />
          {/*<FormattedHTMLMessage id="pages:home:news-sub-title" />*/}
          <FormattedHTMLMessage id='pages:home:news-content' />
        </div>
      </a>
      <a href={`/new-partnership?l=${languageID}`} style={{marginTop: 0, top: ''}} target='_blank'>
        <div
          className='news-image'
          style={{ backgroundImage: 'url("images/icons/news.png")', paddingTop: '0px' }}
        >
          <span><img src="images/logotypes/sli-white.png" style={{ width: '95px', marginLeft: '100px' }} /></span>
          {/* <FormattedHTMLMessage id='pages:home:news-title' /> */}
          {/*<FormattedHTMLMessage id="pages:home:news-sub-title" />*/}
          <FormattedHTMLMessage  id='pages:home:news-content-2' />
        </div>
      </a>
      <FormattedHTMLMessage id='pages:home:title' />
    </Section>
  );
};



// WEBPACK FOOTER //
// ./src/sections/Home.js